import buildingImg from "./../../assets/building.svg";

const Upgrading = () => {
  return (
    <div className="w-full h-full flex items-center flex-col justify-center">
      <img src={buildingImg} alt="" className="w-[300px] h-[400px]" />
      <div className="mt-8 text-[20px] px-6">
        We are seeing unusually high demand. We are upgrading our systems and
        should be back up soon. Please{" "}
        <a href="/" className="underline">
          try again
        </a>{" "}
        after some time.
      </div>
    </div>
  );
};

export default Upgrading;
